import { isBoolean, isEmpty, isNumber, isObject, isString, keyBy, map } from "lodash"
import { convertArrayToIdsString } from "utils/formatter"
import { isArray } from "lodash"
import { statuses } from "keys"

const getScoreRatingFilters = ({ assessmentFilters }) => {
    const { year, category, methods, grade_of_execution, semester } = assessmentFilters

    let params = {}

    if (category)
        params.category = category?.id || category
    if (!isEmpty(methods)) params.methods =
        isArray(methods) ?
            convertArrayToIdsString(methods) :
            methods.id
    if (year)
        params.year = year?.id || year
    if (semester)
        params.semester = semester?.id || semester
    if (grade_of_execution)
        params.grade_of_execution = grade_of_execution?.id || grade_of_execution

    params.status = statuses.inProgress
    params.sub_status = statuses.wordsComplete

    return params
}

const getCustomAssessmentStatuses = (generalStatus) => {
    if (generalStatus && !isEmpty(generalStatus)) {
        let status = ''
        let sub_status = ''

        const statusKeys = keyBy(generalStatus, "status")
        // לא בוצע
        if (statusKeys.undone) {
            status += `,${statuses.created}`
        }
        // כולל את כל הסטטוסים הקשורים למבדק שבוצע - בוצע, בהעלאה, התחיל סימון , סיום סימון
        if (statusKeys.done) {
            status += `,${statuses.uploaded},${statuses.uploading},${statuses.inProgress}`
        }
        // בוצע - בוצע אך עוד לא התחיל סימון
        if (statusKeys.file_uploaded) {
            status += `,${statuses.uploaded}`
        }
        // בוצע וממתין בהעלאה - עוד לא התחיל סימון
        if (statusKeys.uploading) {
            status += `,${statuses.uploading}`
        }
        //   בעיבוד - התחיל סימון / הוחזר לסימון
        if (statusKeys.in_progress) {
            status += `,${statuses.inProgress},${statuses.backToMarking}`
            sub_status += `,${statuses.wordsInProgress},${statuses.recheckPending}`
        }
        // הופק דוח - סימון הסתיים
        if (statusKeys.completed) {
            status += `,${statuses.inProgress}`
            sub_status += `,${statuses.wordsComplete}`
        }
        //  חלף המועד
        if (statusKeys.missed) {
            status += `,${statuses.missed}`
        }
        // לא לביצוע
        if (statusKeys.not_for_execution) {
            status += `,${statuses.notForExecution}`
        }

        // לביצוע חוזר \ קובץ תקול
        if (statusKeys.redo) {
            status += `,${statuses.redo},${statuses.brokenFile}`
        }

        return { status: status.slice(1), sub_status: sub_status.slice(1) }
    }
    return {}
}

const getAssessmentFilters = (headerFilters, assessmentFilters, statusFilters, currentTestTaker) => {
    const { learning_units, cities, city } = headerFilters || {}
    let { semesters, isBattery, marking_words_update_by, visibility_status, school_year, activated_by, structure, method, status: generalStatus, year, semester, categories, gender, assessment_defs, assessment_def, category, grade_of_execution, grade_of_allocation, battery, semester_and_year, grade_group } = assessmentFilters || {}
    const { exclude_audio_status, exclude_sub_status, audio_status, status, sub_status, workflowState } = statusFilters || {}

    let params = getTestTakerFilters(headerFilters)
    const { status: custom_status, sub_status: custom_sub_status } = getCustomAssessmentStatuses(generalStatus)

    if (workflowState)
        params.workflow_state = workflowState

    if (structure) {
        if (structure.id === "SINGLE") {
            params.is_battery = false
        }
    }

    if (semester_and_year) {
        semester = semester_and_year.semester
        school_year = semester_and_year.school_year
    }

    if (marking_words_update_by) params.marking_words_update_by = marking_words_update_by.id || marking_words_update_by

    if (custom_status) params.status = custom_status

    if (custom_sub_status) params.sub_status = custom_sub_status

    if (visibility_status) params.visibility_status = visibility_status?.id || visibility_status

    if (method) params.method = method?.id || method

    if (isBoolean(isBattery)) params.is_battery = isBattery

    if (activated_by) params.activated_by = activated_by?.id

    if (school_year) params.school_year = school_year?.id || school_year

    if (battery) params.battery = battery.id

    else if (currentTestTaker) params.test_taker = currentTestTaker.test_taker_id

    if (status) params.status = map(status).join(',')

    if (audio_status) params.audio_status = map(audio_status).join(',')

    if (exclude_sub_status) params.exclude_sub_status = map(exclude_sub_status).join(',')

    if (exclude_audio_status) params.exclude_audio_status = map(exclude_audio_status).join(',')

    if (gender) params.gender = gender.id

    // grade_of_execution יוצא משימוש תמיד נשתמש ב
    if (grade_of_allocation) params.grade_of_allocation = grade_of_allocation?.id || grade_of_allocation

    if (grade_of_execution) params.grade_of_execution = grade_of_execution?.id || grade_of_execution

    if (grade_group) params.grade_group = grade_group?.id || grade_group

    // כשהמפתח מוגדר ברבים
    if (!isEmpty(cities))
        params.cities = convertArrayToIdsString(cities)

    // כשהמפתח מוגדר ביחיד
    if (isObject(city) || isNumber(city))
        params.cities = convertArrayToIdsString([city])

    // כשהמפתח מוגדר ברבים
    if (!isEmpty(semesters))
        params.semesters = convertArrayToIdsString(semesters)

    // כשהמפתח מוגדר ביחיד
    if (isObject(semester) || isNumber(semester) || isString(semester))
        params.semester = semester?.id || semester

    // כשהמפתח מוגדר ברבים
    if (!isEmpty(categories))
        params.categories = convertArrayToIdsString(categories)

    // כשהמפתח מוגדר ביחיד
    if (isObject(category) || isNumber(category))
        params.category = category?.id || category

    // בדיקה עבור יחיד ורבים
    if (sub_status)
        if (isArray(sub_status))
            params.sub_status = map(sub_status).join(',')
        else params.sub_status = sub_status

    // כשהמפתח מוגדר ברבים
    if (!isEmpty(assessment_defs))
        params.assessment_defs = convertArrayToIdsString(assessment_defs)

    // כשהמפתח מוגדר ביחיד
    if (isObject(assessment_def) || isNumber(assessment_def))
        params.assessment_defs = convertArrayToIdsString([assessment_def])

    return params

}

const getTestTakerFilters = (filters) => {
    const { home_grade, home_grades, home_affiliation, home_affiliations, learning_units, learning_unit, group, learning_group, learning_groups, school_class, city, affiliation, affiliations, grade, grades, school_classes, groups, test_taker, test_takers } = filters || {}

    let params = {}
    if (!isEmpty(city))
        params.city = city?.id || city

    if (learning_unit || learning_units) {
        if (isObject(learning_unit) || isNumber(learning_unit))
            params.learning_units = convertArrayToIdsString([learning_unit])

        if (!isEmpty(learning_units))
            params.learning_units = convertArrayToIdsString(learning_units)
    }
    else {

        if (!isEmpty(groups))
            params.groups = convertArrayToIdsString(groups)

        if (isObject(group) || isNumber(group))
            params.groups = convertArrayToIdsString([group])

        if (!isEmpty(affiliations))
            params.affiliations = convertArrayToIdsString(affiliations)

        if (isObject(affiliation) || isNumber(affiliation))
            params.affiliations = convertArrayToIdsString([affiliation])

        if (!isEmpty(home_affiliations))
            params.home_affiliations = convertArrayToIdsString(grades)

        if (isObject(home_affiliation) || isNumber(home_affiliation))
            params.home_affiliations = convertArrayToIdsString([home_affiliation])

        if (!isEmpty(grades))
            params.grades = convertArrayToIdsString(grades)

        if (isObject(grade) || isNumber(grade))
            params.grades = convertArrayToIdsString([grade])

        if (!isEmpty(home_grades))
            params.home_grades = convertArrayToIdsString(home_grades)

        if (isObject(home_grade) || isNumber(home_grade))
            params.home_grades = convertArrayToIdsString([home_grade])


        if (!isEmpty(school_classes))
            params.learning_units = convertArrayToIdsString(school_classes)

        if (isObject(school_class) || isNumber(school_class))
            params.learning_units = convertArrayToIdsString([school_class])
        // params.school_classes = convertArrayToIdsString([school_class])

        if (isObject(learning_group) || isNumber(learning_group))
            params.learning_units = convertArrayToIdsString([learning_group])

        if (!isEmpty(learning_groups))
            params.learning_units = convertArrayToIdsString(learning_groups)

    }

    if (!isEmpty(test_takers))
        params.test_takers = convertArrayToIdsString(test_takers)

    if (test_taker)
        params.test_takers = convertArrayToIdsString([test_taker])


    return params
}

const completedParams = {
    status: statuses.inProgress,
    sub_status: statuses.wordsComplete
}

export { completedParams, getTestTakerFilters, getScoreRatingFilters, getAssessmentFilters }